export default "__VITE_ASSET__Brfc1Gkl__"